var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9007 5.6295C18.9022 3.99244 15.5641 2.6665 11.4511 2.6665C7.33809 2.6665 4.00298 3.99393 4 5.6295M4 5.6295C4 7.26655 7.33511 8.59249 11.4511 8.59249C15.5671 8.59249 18.9022 7.26655 18.9022 5.6295L18.9022 17.1258M4 5.6295V23.4074C4.00149 25.0444 7.3366 26.3704 11.4511 26.3704C13.4465 26.3704 15.2482 26.0548 16.5849 25.5466M4.00149 11.5555C4.00149 13.1925 7.3366 14.5185 11.4526 14.5185C15.5686 14.5185 18.9037 13.1925 18.9037 11.5555M16.6743 19.5927C15.3301 20.1186 13.4867 20.4445 11.4511 20.4445C7.3366 20.4445 4.00149 19.1186 4.00149 17.4815M27.3696 17.9527C29.9879 20.5557 29.9879 24.7779 27.3696 27.3809C24.7513 29.9839 20.5042 29.9839 17.8859 27.3809C15.2675 24.7779 15.2675 20.5557 17.8859 17.9527C20.5042 15.3497 24.7513 15.3497 27.3696 17.9527Z",
    stroke: "#0C4ACF",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinStack);
export default __webpack_public_path__ + "static/media/coin-stack.027f112b19bb663ab02f254e5e80f3f6.svg";
export { ForwardRef as ReactComponent };